import { useState } from "react";
import LineChart from "../../components/LineChart";

export default function WeightGraph({ chartData }) {
  const [data, setData] = useState({
    labels: chartData.map((data) => data.date),
    datasets: [
      {
        label: "Weight",
        data: chartData.map((data) => data.weight),
      },
    ],
  });
  return (
    <div className="w-full max-h-96">
      <LineChart chartData={data} />
    </div>
  );
}
